<h3-region-of-interest-setting-toggle
  label="Camera Field of View"
  [value]="viewBoxHighlightValueLabel$ | async"
  name="cameraFov"
  [checked]="viewBoxHighlightEnabledStore.$ | async"
  (changeEventEmitter)="trackHighlightEnabledChange()"
  [disabled]="isSplitViewOff$ | async"
>
</h3-region-of-interest-setting-toggle>

<mat-divider></mat-divider>

<h3-region-of-interest-setting-toggle
  label="Camera Distance"
  [value]="cameraRoiDistanceEnabledLabel$ | async"
  name="cameraDistance"
  [checked]="cameraRoiDistanceStore('enabled').$ | async"
  (changeEventEmitter)="trackCameraDistanceToggle()"
>
</h3-region-of-interest-setting-toggle>

@if (cameraRoiDistanceStore('enabled').$ | async) {
  <h3-region-of-interest-distance></h3-region-of-interest-distance>
}
